import React from "react";

import writingHw from "../../../resources/bookshelf.png";
import bookshelf from "../../../resources/events/writing-hw.png";

import Checkmark from "../../common/Checkmark";
import Row from "../../common/Row";
import Classes from "./Classes";
import { useTranslation } from "react-i18next";

const Education = () => {
  const { t } = useTranslation("education");

  return (
    <div>
      <div className="text-white bg-emerald-500 h-50 p-8">
        <p className="text-4xl text-center">{t("education.hero")}</p>

        <Row>
          <div className="space-y-4 text-left p-8">
            <ul className="space-y-4 mt-4">
              <li className="flex items-center">
                <Checkmark />
                <p className="ml-4">{t("education.features.f1")}</p>
              </li>
              <li className="flex items-center">
                <Checkmark />
                <p className="ml-4">{t("education.features.f2")}</p>
              </li>
              <li className="flex items-center">
                <Checkmark />
                <p className="ml-4">{t("education.features.f3")}</p>
              </li>
            </ul>
          </div>

          <div className="space-y-4 text-left p-8">
            <ul className="space-y-4 mt-4">
              <li className="flex items-center">
                <Checkmark />
                <p className="ml-4">{t("education.features.f4")}</p>
              </li>
              <li className="flex items-center">
                <Checkmark />
                <p className="ml-4">{t("education.features.f5")}</p>
              </li>
              <li className="flex items-center">
                <Checkmark />
                <p className="ml-4">{t("education.features.f6")}</p>
              </li>
            </ul>
          </div>
        </Row>
      </div>

      {/* Section: Most effective learning */}
      <div className="bg-gray-100 text-center py-4">
        <div className="text-2xl text-emerald-600 py-4 font-bold">
          <Row spaceClass="md:space-x-2">
            <div>{t("education.tagline.line1")}</div>
            <div>{t("education.tagline.line2")}</div>
          </Row>
        </div>
      </div>

      {/* Section: Online / in-person classes */}
      <div className="text-center py-4">
        <div className="text-2xl text-emerald-600 py-4 font-bold">
          {t("education.mode")}
        </div>
        <div className="md:w-3/4 mx-auto">
          <Classes />
        </div>
      </div>

      {/* Section: Skills foundation */}
      <div className="bg-gray-100 text-center py-4">
        <div className="text-2xl text-emerald-600 py-4 font-bold">
          <Row spaceClass="md:space-x-2">
            <div>{t("education.foundation.line1")}</div>
            <div>{t("education.foundation.line2")}</div>
          </Row>
        </div>
      </div>

      {/* Section: Writing course */}
      <div className="space-y-16 m-16">
        <Row>
          <div className="mb-4 space-y-4 md:order-2 md:ml-16">
            <div className="text-xl font-bold text-left">{t("education.writing.title")}</div>

            <div className="text-sm text-left">{t("education.writing.body")}</div>

            <div className="text-sm text-left font-bold">{t("education.writing.beginner")}</div>
            <ul className="list-disc text-sm">
              <li>{t("education.writing.b1")}</li>
              <li>{t("education.writing.b2")}</li>
              <li>{t("education.writing.b3")}</li>
            </ul>

            <div className="text-sm text-left font-bold">{t("education.writing.advanced")}</div>
            <ul className="list-disc text-sm">
              <li>{t("education.writing.a1")}</li>
              <li>{t("education.writing.a2")}</li>
              <li>{t("education.writing.a3")}</li>
              <li>{t("education.writing.a4")}</li>
            </ul>
          </div>

          <img src={writingHw} alt="img not found" className="rounded-xl md:order-1" />
        </Row>

        {/* Section: Book reading */}
        <Row spaceClass="md:space-x-16">
          <div className="mb-4 md:w-1/3 space-y-4">
            <div className="text-xl font-bold text-left">{t("education.reading.title")}</div>

            <div className="text-sm text-left">{t("education.reading.body")}</div>
          </div>

          <img src={bookshelf} alt="img not found" className="md:w-1/2 rounded-xl" />
        </Row>
      </div>
    </div>
  );
};

export default Education;
